var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4433_8853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08301 8.66699C1.08301 7.13493 1.08301 6.3689 1.55896 5.89294C2.03491 5.41699 2.80094 5.41699 4.33301 5.41699H8.66634C10.1984 5.41699 10.9644 5.41699 11.4404 5.89294C11.9163 6.3689 11.9163 7.13493 11.9163 8.66699C11.9163 10.1991 11.9163 10.9651 11.4404 11.441C10.9644 11.917 10.1984 11.917 8.66634 11.917H4.33301C2.80094 11.917 2.03491 11.917 1.55896 11.441C1.08301 10.9651 1.08301 10.1991 1.08301 8.66699Z",
    stroke: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 5.41634V4.33301C3.25 2.53808 4.70507 1.08301 6.5 1.08301C8.29493 1.08301 9.75 2.53808 9.75 4.33301V5.41634",
    stroke: "#121212",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4433_8853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.20519474db992e568fa1e2dc1272cb2a.svg";
export { ForwardRef as ReactComponent };